export enum ShortcutTypes {
	Shared = 0,
	Personal = 1,
}
